import { useEffect } from 'react'
import { connect } from 'react-redux'
import { selectors } from '../../store/modules/tracking'

const { getPush, getType, getMeta } = selectors

export function TrackingManager({ push, type, meta }) {
  useEffect(
    () => {
      const Thor = window.thor
      if (Thor && push && push.isRequired && type && meta) {
        Thor.pushEvent(type, {
          ...meta,
        })
      }
    },
    [push],
  )

  return null
}

export const mapStateToProps = state => ({
  push: getPush(state),
  type: getType(state),
  meta: getMeta(state),
})

export default connect(
  mapStateToProps,
  null,
)(TrackingManager)
